var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelicopter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "10 40 250 200",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .statusFill {\n            fill: #2A6FAE;\n        }\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer4",
    transform: "matrix(10,0,0,10,-70,-70)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.18146,0,0,1.18146,5.0601,9.92821)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.028,
    cy: 5.139,
    r: 2.539,
    className: "statusFill"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.59472,0,0,1.29736,-46.2675,-12.0695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.686,21.25C29.055,21.25 30.164,23.469 30.164,26.207L30.164,26.208C30.164,26.889 30.013,27.534 29.752,27.97C29.491,28.406 29.146,28.588 28.811,28.466C28.239,28.258 27.581,28.019 27.038,27.822C26.376,27.581 25.868,26.507 25.784,25.171C25.739,24.449 25.69,23.662 25.648,22.983C25.62,22.544 25.688,22.103 25.835,21.772C25.981,21.44 26.191,21.25 26.413,21.25L27.686,21.25Z",
    className: "statusFill"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1,0,0,0.1,7,7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.324,195L130,195C127.24,195 125,197.24 125,200C125,202.76 127.24,205 130,205L230,205C243.807,205 255,193.807 255,180C255,177.241 252.76,175 250,175C247.24,175 245,177.241 245,180C245,187.421 239.611,193.583 232.534,194.787L214.16,167.226C212.63,164.93 209.523,164.309 207.226,165.84C204.93,167.37 204.309,170.477 205.84,172.774L220.657,195L159.343,195L174.16,172.774C175.691,170.477 175.07,167.37 172.774,165.84C170.477,164.309 167.37,164.93 165.84,167.226L147.324,195ZM185,55L130,55C127.24,55 125,57.24 125,60C125,62.76 127.24,65 130,65L185,65L185,85L40,85C37.548,85 35.457,86.778 35.065,89.199C34.672,91.62 36.092,93.968 38.419,94.743L158.419,134.743C161.037,135.616 163.871,134.199 164.743,131.581C165.616,128.963 164.199,126.129 161.581,125.257L70.811,95L185,95L185,123.057C185,135.278 193.835,145.708 205.89,147.717C215.498,149.319 227.379,151.298 236.305,152.633C241.214,153.436 246.199,151.727 249.584,148.08C252.979,144.422 254.31,139.302 253.125,134.454C253.124,134.451 253.124,134.449 253.123,134.447C246.529,107.637 223.282,87.344 195,85.19L195,65L250,65C252.76,65 255,62.76 255,60C255,57.24 252.76,55 250,55L195,55L195,50C195,47.24 192.76,45 190,45C187.24,45 185,47.24 185,50L185,55ZM195,95.227L195,123.057C195,130.39 200.301,136.648 207.534,137.853C217.103,139.448 228.939,141.421 237.82,142.749C237.848,142.753 237.876,142.757 237.903,142.762C239.511,143.03 241.146,142.472 242.255,141.277C243.363,140.083 243.797,138.413 243.411,136.83C237.89,114.393 218.582,97.354 195,95.227Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelicopter);
export default __webpack_public_path__ + "static/media/helicopter.6ec8dd944eb248dace0eb0e8707bdadd.svg";
export { ForwardRef as ReactComponent };